@if (producerDetails()) {
@defer (when !loadingProducts()) {
<div class="row mb-3">
  <div class="col-sm-4">
    <img src="{{ producerDetails()?.img }}" class="img-fluid" (error)="handleImageError($event)"
      alt="{{ producerDetails()?.name}}" />
  </div>
  <div class="col-sm-8">
    <h2 class="section-title">{{ producerDetails()?.name }}</h2>
    @defer(on viewport) {
    <div [innerHTML]="sanitizeHtml(producerDetails().description)"></div>
    } @placeholder {
    <div></div>
    }
  </div>
</div>

<hr class="is-thick my-5">

@defer (on viewport) {
@if(carouselProducerProducts().length) {
<h2 class="section-title mb-2">
  Their products
</h2>
<div class="row">
  <app-carousel [items]="carouselProducerProducts()" [type]="'producerProduct'"
    [hasMoreItems]="producerDetails()?.hasMoreProducts"></app-carousel>
</div>
}
} @placeholder{
<div></div>
}
} @placeholder (minimum 300ms) {
<h1 class="h2-semibold text-primary head-font">
  Loading...
</h1>
}
}